export default {
  customerStats: [],

  clubJauge: undefined,
  isLoadingJauge: false,
}
